import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditForm from '../adminPages/EditForm';

const EditModal = ({ styles }) => (
  <>
    <DialogTitle id="responsive-dialog-title" style={styles.title}>Edit user details</DialogTitle>
    <DialogContent style={styles.content}>
      <EditForm />
    </DialogContent>
  </>
);
export default EditModal;
